module.exports = __webpack_public_path__ + "img/z13.20b5daff.jpg";